import { Outlet, useLocation } from 'react-router-dom'
import { NAVIGATION_GROUPS } from '../../navigation'
import { findNavigationMatch } from '../helpers/findNavigationMatch'
import { PageHeader } from '../PageHeader/PageHeader'

export function ActionsLayout() {
  const { pathname } = useLocation()
  const match = findNavigationMatch(NAVIGATION_GROUPS, pathname)

  return (
    <>
      <PageHeader
        title={match?.item.label ?? 'Operations'}
        description="Each operation starts a one-off job. The API confirms that it accepted the request, not the outcome of the job."
      />
      <section className="content-card content-card--padded">
        <Outlet />
      </section>
    </>
  )
}
